import PubSub from './utils/pubsub';

class Store extends PubSub {
  static create() {
    return new Store();
  }

  constructor() {
    super();
    this.state = {};
  }

  set(key, data) {
    this.state[key] = data;
    this.publish(key, data);
  }

  get(key) {
    return this.state[key];
  }
}

export default Store;
